const Bed = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-bed"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-bed"
      viewBox="0 0 16 15"
      width={_width}
      {...props}
    >
      <g clip-path="url(#clip0_268_3146)">
        <path
          d="M6.125 5.9375C6.125 6.24653 6.03336 6.54863 5.86167 6.80558C5.68998 7.06253 5.44595 7.2628 5.16044 7.38106C4.87493 7.49932 4.56077 7.53027 4.25767 7.46998C3.95458 7.40969 3.67617 7.26087 3.45765 7.04235C3.23913 6.82383 3.09031 6.54542 3.03002 6.24233C2.96973 5.93923 3.00068 5.62507 3.11894 5.33956C3.2372 5.05405 3.43747 4.81002 3.69442 4.63833C3.95137 4.46664 4.25347 4.375 4.5625 4.375C4.9769 4.375 5.37433 4.53962 5.66735 4.83265C5.96038 5.12567 6.125 5.5231 6.125 5.9375ZM15.5 7.5V6.25C15.5 5.58696 15.2366 4.95107 14.7678 4.48223C14.2989 4.01339 13.663 3.75 13 3.75H9.875C9.21196 3.75 8.57607 4.01339 8.10723 4.48223C7.63839 4.95107 7.375 5.58696 7.375 6.25V7.5H15.5ZM1.75 8.75V1.875C1.75 1.70924 1.68415 1.55027 1.56694 1.43306C1.44973 1.31585 1.29076 1.25 1.125 1.25C0.95924 1.25 0.800268 1.31585 0.683058 1.43306C0.565848 1.55027 0.5 1.70924 0.5 1.875L0.5 13.125C0.5 13.2908 0.565848 13.4497 0.683058 13.5669C0.800268 13.6842 0.95924 13.75 1.125 13.75C1.29076 13.75 1.44973 13.6842 1.56694 13.5669C1.68415 13.4497 1.75 13.2908 1.75 13.125V11.875H14.25V13.125C14.25 13.2908 14.3158 13.4497 14.4331 13.5669C14.5503 13.6842 14.7092 13.75 14.875 13.75C15.0408 13.75 15.1997 13.6842 15.3169 13.5669C15.4342 13.4497 15.5 13.2908 15.5 13.125V8.75H1.75Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_268_3146">
          <rect
            width="15"
            height="15"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Bed;
